import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { memo, useMemo } from "react";
import { colors } from "../../utils/const";
import { convertSpacesToHyphens } from "@/utils/general-functions";
import Image from "next/image";
import { useI18n } from "@/i18n/I18nProvider";
import Link from "next/link";


function News({ items = [], buisness = false }) {
  const { t, locale } = useI18n();
  const isAr = locale === "ar";

  // احسب href/preview مرة واحدة لكل item (بدل 3 مرات)
  const cards = useMemo(() => {
    return (items || []).map((item) => {
      const slug = convertSpacesToHyphens(
        (item.urlTitle || "").toLocaleLowerCase()
      );
      const href = `/media/${item.id}/${slug}`;
      const preview =
        (item.sections?.[0] || "").substring(0, buisness ? 150 : 100) + "...";
      return { item, href, preview };
    });
  }, [items, buisness]);

  const imageHeight = buisness ? 400 : 300;

  return (
    <Grid container spacing={6}>
      {cards.map(({ item, href, preview }) => (
        <Grid key={item.id} item xs={12} md={6} lg={buisness ? 6 : 4}>
          <Box>
            {/* CLS: حجز مساحة ثابتة للصورة */}
            <Box
              component={Link}
              href={href}
              // prefetch={false}
              aria-label={`Open media: ${item.title}`}
              sx={{ textDecoration: "none" }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  height: `${imageHeight}px`,
                  borderRadius: 2,
                  overflow: "hidden",
                  bgcolor: "##F8F8F8"                }}
              >
                <Image
                  alt={item.title}
                  src={item.img}
                  fill
                  // LCP/Performance: sizes يخلي Next يختار حجم مناسب
                  sizes={
                    buisness
                      ? "(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 50vw"
                      : "(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  }
                  style={{ objectFit:  buisness ?  "contain" :"cover" }}
                  // LCP: خفف الجودة بدل 100 (فرق كبير جدًا في الحجم)
                  quality={80}
                  // lazy default لو مش priority
                />
              </Box>
            </Box>

            <Box
              component={Link}
              href={href}
              // prefetch={false}
              sx={{
                textDecoration: "none",
                "&:hover": { color: colors.blue },
              }}
            >
              <Box
                sx={{
                  fontWeight: "bold",
                  my: 2,
                  color: colors.blue,
                  fontSize: "18px",
                  ml: isAr ? { xs: 4, md: 0 } : 0,
                  mr: !isAr ? { xs: 4, md: 0 } : 0,
                  // optional: يقلل تغير ارتفاع الكروت
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  minHeight: "48px",
                }}
              >
                {item.title}
              </Box>
            </Box>

            <Box
              component={Link}
              href={href}
              // prefetch={false}
              aria-label={`Go to media page for ${item.title}`}
              sx={{
                textDecoration: "none",
                "&:hover": { color: colors.v_dark_grey },
              }}
            >
              <Box
                sx={{
                  color: colors.v_dark_grey,
                  ml: isAr ? { xs: 4, md: 0 } : 0,
                  mr: !isAr ? { xs: 4, md: 0 } : 0,
                  mb: 2,
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  minHeight: "72px",
                }}
              >
                {preview}
              </Box>
            </Box>

            <Box
              component={Link}
              href={href}
              prefetch={false}
              sx={{
                color: colors.ratty,
                fontSize: "14px",
                fontWeight: "bold",
                textDecoration: "none",
                "&:hover": { color: colors.ratty },
              }}
            >
              {t.news.read_more}
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}

export default memo(News);
